import { ReferenceTableItemDeletedEvent, } from '../event/reference-table-item-deleted.event';
const referenceTableItemDeletedProjections = {
    [ReferenceTableItemDeletedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        const newItems = new Map(state.items);
        newItems.delete(payload.itemId);
        return {
            ...state,
            items: newItems,
        };
    },
};
export default referenceTableItemDeletedProjections;
//# sourceMappingURL=reference-table-item-deleted.projection.js.map